import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f6646f3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fields" }
const _hoisted_2 = { class: "field" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-label" }, "Type", -1))
const _hoisted_4 = { class: "field" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-label" }, "Date", -1))
const _hoisted_6 = { class: "field" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-label" }, "Value", -1))
const _hoisted_8 = { class: "field" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-label" }, "Place", -1))
const _hoisted_10 = { class: "field" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-label" }, "Flag", -1))
const _hoisted_12 = { class: "flag-row" }
const _hoisted_13 = { class: "form-check" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "detail-highlight"
}, "Highlight", -1))

import { ref } from 'vue'
import { GameCardDetail } from './GamesApi'
import Modal from '@/util/Modal.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'EditDetailModal',
  emits: ["save", "delete"],
  setup(__props, { expose: __expose, emit }) {



__expose({
  open: (detail: GameCardDetail) => {
    draftRef.value = { ...detail }
    modalRef.value?.open()
  },
  close: () => modalRef.value?.close(),
})

const draftRef = ref<GameCardDetail>({ type: '' })

const modalRef = ref<InstanceType<typeof Modal>>()

function onOk() {
  const draft = draftRef.value
  const detail: GameCardDetail = { type: draft.type }
  if (draft.date) {
    detail.date = draft.date
  }
  if (draft.value) {
    detail.value = draft.value
  }
  if (draft.place) {
    detail.place = draft.place
  }
  if (draft.flag) {
    detail.flag = draft.flag
  }
  if (draft.highlight) {
    detail.highlight = true
  }
  emit('save', detail)
}

function onDelete() {
  emit('delete')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    ref_key: "modalRef",
    ref: modalRef,
    "ok-text": "Save",
    "ok-close": "",
    onOk: onOk
  }, {
    title: _withCtx(() => [
      _createTextVNode("Edit detail")
    ]),
    secondaryContent: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-outline-danger",
        onClick: onDelete
      }, "Delete")
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("label", _hoisted_2, [
          _hoisted_3,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((draftRef.value.type) = $event))
          }, null, 512), [
            [
              _vModelText,
              draftRef.value.type,
              void 0,
              { trim: true }
            ]
          ])
        ]),
        _createElementVNode("label", _hoisted_4, [
          _hoisted_5,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((draftRef.value.date) = $event)),
            placeholder: "e.g. +1917-12-20"
          }, null, 512), [
            [
              _vModelText,
              draftRef.value.date,
              void 0,
              { trim: true }
            ]
          ])
        ]),
        _createElementVNode("label", _hoisted_6, [
          _hoisted_7,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((draftRef.value.value) = $event))
          }, null, 512), [
            [
              _vModelText,
              draftRef.value.value,
              void 0,
              { trim: true }
            ]
          ])
        ]),
        _createElementVNode("label", _hoisted_8, [
          _hoisted_9,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((draftRef.value.place) = $event))
          }, null, 512), [
            [
              _vModelText,
              draftRef.value.place,
              void 0,
              { trim: true }
            ]
          ])
        ]),
        _createElementVNode("label", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("span", _hoisted_12, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control flag-input",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((draftRef.value.flag) = $event)),
              placeholder: "e.g. us",
              maxlength: "6"
            }, null, 512), [
              [
                _vModelText,
                draftRef.value.flag,
                void 0,
                { trim: true }
              ]
            ]),
            (draftRef.value.flag)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass(["fi", `fi-${draftRef.value.flag}`])
                }, null, 2))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _withDirectives(_createElementVNode("input", {
            id: "detail-highlight",
            class: "form-check-input",
            type: "checkbox",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((draftRef.value.highlight) = $event))
          }, null, 512), [
            [_vModelCheckbox, draftRef.value.highlight]
          ]),
          _hoisted_14
        ])
      ])
    ]),
    _: 1
  }, 512))
}
}

})